// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#mocha a {
  text-decoration: none;
}
#mocha > ul#mocha-stats {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0;
  font-size: 16px;
}
#mocha > ul#mocha-stats > li {
  display: block;
  text-transform: uppercase;
}
#mocha > ul#mocha-stats > li > em {
  font-style: normal;
}
#mocha > ul#mocha-stats > li.progress {
  transform-origin: left top;
  scale: 0.5;
  width: 48px;
  height: 48px;
}
#mocha > ul#mocha-report,
#mocha > ul#mocha-report ul {
  padding-left: 24px;
}
#mocha > ul#mocha-report h1,
#mocha > ul#mocha-report h2 {
  display: flex;
  margin: 4px 0;
  padding: 0;
  font-weight: normal;
  font-size: 16px;
  line-height: 1.55;
}
#mocha > ul#mocha-report li::marker {
  content: "⏺ ";
  color: var(--text-secondary);
}
#mocha > ul#mocha-report li.suite > h1 > a {
  text-decoration: none;
}
#mocha > ul#mocha-report li.pass::marker {
  color: var(--success);
}
#mocha > ul#mocha-report li.fail::marker {
  color: var(--error);
}
#mocha > ul#mocha-report .duration {
  margin: 0 12px;
  color: var(--text-secondary);
}
#mocha > ul#mocha-report .replay {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/jsrealm/nodepkg/jsrealm/testentry/driver/mocha.less"],"names":[],"mappings":"AAAA;EAEQ,qBAAA;AAAR;AAFA;EAMQ,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AADR;AATA;EAaY,cAAA;EACA,yBAAA;AADZ;AAbA;EAiBgB,kBAAA;AADhB;AAIY;EACI,0BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAFhB;AAQQ;;EAEI,kBAAA;AANZ;AA1BA;;EAqCY,aAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAPZ;AAWY;EACI,aAAA;EACA,4BAAA;AAThB;AAYY;EACI,qBAAA;AAVhB;AA1CA;EAyDY,qBAAA;AAZZ;AA7CA;EA6DY,mBAAA;AAbZ;AAhDA;EAiEY,cAAA;EACA,4BAAA;AAdZ;AApDA;EAsEY,iBAAA;AAfZ","sourcesContent":["#mocha {\n    a {\n        text-decoration: none;\n    }\n\n    > ul#mocha-stats {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 0;\n        font-size: 16px;\n\n        > li {\n            display: block;\n            text-transform: uppercase;\n\n            > em {\n                font-style: normal;\n            }\n\n            &.progress {\n                transform-origin: left top;\n                scale: 0.5;\n                width: 48px;\n                height: 48px;\n            }\n        }\n    }\n\n    > ul#mocha-report {\n        &,\n        ul {\n            padding-left: 24px;\n        }\n\n        h1,\n        h2 {\n            display: flex;\n            margin: 4px 0;\n            padding: 0;\n            font-weight: normal;\n            font-size: 16px;\n            line-height: 1.55;\n        }\n\n        li {\n            &::marker {\n                content: \"⏺ \";\n                color: var(--text-secondary);\n            }\n\n            &.suite > h1 > a {\n                text-decoration: none;\n            }\n        }\n\n        li.pass::marker {\n            color: var(--success);\n        }\n\n        li.fail::marker {\n            color: var(--error);\n        }\n\n        .duration {\n            margin: 0 12px;\n            color: var(--text-secondary);\n        }\n\n        .replay {\n            margin-left: auto;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
